


































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import UiHexagon from '@/components/UiHexagon.vue';
@Component({components: {UiHexagon}})
export default class UiWindow extends Vue {

  @Prop() public visible!: boolean;
  @Prop() public buttonIcon!: string;
  @Prop() public hexagonColor!: string;
  @Prop() public hexagonBorderColor!: string;

  public isVisible: boolean = false;
  public animationClass: string = 'mt-n12 animation-start';

  @Watch('visible') private onVisibleChanged(): void {
    this.isVisible = this.visible;
    this.animationClass = 'mt-n12 animation-start';
    if (this.isVisible) {
      setTimeout(() => {
        this.animationClass = 'mt-n12 animation-stop';
      }, 10);
    }
  }

  private click(): void {
    this.isVisible = false;
    this.$emit('update:visible', this.isVisible);
    this.$emit('click');
  }
}
